<template>
  <div
    class="mt-4 mx-3 row white-box px-3 py-4"
    v-if="crmCategories !== undefined"
  >
    <div class="white-box-top"></div>
    <div class="col-md-4 col-lg-2">
      <nav class="left-nav">
        <button
          v-for="crmCategory in crmCategories"
          :key="crmCategory.id"
          class="btn w-100 text-start"
          v-on:click="active = crmCategory.slug"
          :class="active === crmCategory.slug ? 'btn-primary' : 'btn-simple'"
        >
          {{ crmCategory.name }}
        </button>
        <button
          class="btn w-100 text-start"
          :class="!active ? 'btn-primary' : 'btn-simple'"
          v-on:click="active = null"
        >
          + new CRM category
        </button>
        <hr />
        <button
          class="btn w-100 text-start"
          :class="active === 'statuses' ? 'btn-primary' : 'btn-simple'"
          v-on:click="active = 'statuses'"
        >
          CRM Statuses
        </button>
      </nav>
    </div>
    <div class="col-md-8 col-lg-10" v-if="active === null">
      <h2>
        {{ $t("crm.crm") }}
      </h2>
      <h4>Create new CRM category</h4>
      <div class="row text-start custom-input whitebg-input mt-4">
        <div class="row mb-3">
          <div class="col-4 mb-3">
            <label class="form-label bold-12 text-gray">
              {{ $t("session.type") }}
            </label>
            <v-select
              :options="[
                { id: 1, name: 'Partner' },
                { id: 2, name: 'Team' },
                { id: 3, name: 'Customer' },
              ]"
              v-model="newCategory.type"
              label="name"
              :placeholder="$t(`session.type`)"
              :reduce="(c) => c.id"
              append-to-body
            />
          </div>
          <div class="col-5 mb-3">
            <label class="form-label bold-12 text-gray">
              {{ $t("session.name") }}
            </label>
            <input
              type="text"
              class="form-control remove-padding"
              :placeholder="$t(`session.name`)"
              v-model="newCategory.name"
              v-on:focusout="generateSlug()"
            />
          </div>
          <div class="col-3 mb-3">
            <label class="form-label bold-12 text-gray">{{
              $t("webshops.urlSlug")
            }}</label>
            <input
              type="text"
              class="form-control remove-padding"
              placeholder="w-hu"
              v-model="newCategory.slug"
            />
          </div>
          <div class="row">
            <label
              v-for="p in icons"
              :key="p"
              class="col-2 col-md-1 mb-1 text-center"
            >
              <div
                class="
                  border
                  rounded
                  p-3
                  h-100
                  d-flex
                  flex-column
                  align-items-start
                  printer-card
                  text-center
                "
                :class="{ 'border-primary': newCategory.icon === p }"
              >
                <input
                  type="radio"
                  class="form-check-input mb-2"
                  :value="p"
                  v-model="newCategory.icon"
                />
                <BaseIcon :name="p" />
              </div>
            </label>
          </div>
          <div class="row mt-2">
            <div class="col"></div>
            <div class="col-auto">
              <button
                :class="{ 'loading-spin': loadAddBtn }"
                :disabled="loadAddBtn"
                class="btn btn-primary"
                v-on:click="createCategory"
              >
                <span>{{ $t("addRole.create") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8 col-lg-10" v-else-if="active === 'statuses'">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2>CRM Statuses</h2>
      </div>

      <div v-if="statusesLoading" class="text-center py-4">
        <div class="spinner-border" role="status"></div>
      </div>

      <div v-else>
        <OneByOneTable
          :rows="crmStatusRows"
          :items="crmStatuses"
          :showAdd="true"
          :showDel="true"
          :showEdit="false"
          :showChange="false"
          :showTick="false"
          type="status"
          @addbtn="showAddStatusModal"
          @delete="deleteStatus"
          @update:field="updateStatusField"
        />
      </div>
    </div>
    <div class="col-md-8 col-lg-10" v-else>
      <h2>
        {{ $t("crm.crm") }}
      </h2>
      <custom-rows v-model:type="active" />
    </div>

    <div
      ref="addStatusModal"
      class="modal fade"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add CRM Status</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label bold-12 text-gray">Name</label>
              <input
                type="text"
                class="form-control"
                v-model="newStatus.name"
                placeholder="Status name"
              />
            </div>
            <div class="mb-3">
              <label class="form-label bold-12 text-gray">Type</label>
              <v-select
                :options="crmTypes"
                v-model="newStatus.type"
                label="name"
                :reduce="(c) => c.id"
                placeholder="Select type"
                append-to-body
              />
            </div>
            <div class="mb-3">
              <label class="form-label bold-12 text-gray">Color</label>
              <input
                type="color"
                class="form-control form-control-color w-100"
                v-model="newStatus.color"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ 'loading-spin': savingStatus }"
              :disabled="savingStatus"
              v-on:click="createStatus"
            >
              Create Status
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomRows from "@/components/settings/products/CustomRows";
import { useStore } from "vuex";
import BaseIcon from "../icons/BaseIcon.vue";
import OneByOneTable from "../lists/OneByOneTable.vue";
import http from "@/modules/http";
const bootstrap = require("bootstrap");

export default {
  name: "Crm",
  components: { BaseIcon, CustomRows, OneByOneTable },
  data() {
    return {
      store: useStore(),
      active: "partners",
      newCategory: {},
      loadAddBtn: false,
      icons: [
        "partners",
        "customers",
        "partner-add",
        "user-tick",
        "web",
        "bag",
        "user-search",
        "map",
        "shop",
        "clock",
        "messages",
        "share",
        "mail",
      ],
      crmStatuses: [],
      statusesLoading: false,
      savingStatus: false,
      newStatus: {
        name: "",
        type: 3,
        color: "#6c757d",
        is_pay_before: false,
        is_block_customer: false,
        do_not_override: false,
      },
      crmTypes: [
        { id: 1, name: "Partner" },
        { id: 2, name: "Team" },
        { id: 3, name: "Customer" },
      ],
      statusModal: null,
      crmStatusRows: [
        {
          key: "name",
          name: "Name",
          type: "string",
          show: true,
        },
        {
          key: "type",
          name: "Type",
          type: "enum",
          label: "name",
          selectKey: "id",
          values: this.crmTypes,
          show: true,
        },
        {
          key: "color",
          name: "Color",
          type: "color",
          show: true,
        },
        {
          key: "min_order_count",
          name: "Min Order Count",
          type: "number",
          show: true,
        },
        {
          key: "min_order_amount",
          name: "Min Order Amount",
          type: "number",
          show: true,
        },
        {
          key: "active_within_days",
          name: "Active Within Days",
          type: "number",
          show: true,
        },
        {
          key: "registered_within_days",
          name: "Registered Within Days",
          type: "number",
          show: true,
        },
        {
          key: "refused_order_count",
          name: "Refused Order Count",
          type: "number",
          show: true,
        },
        {
          key: "is_pay_before",
          name: "Pay Before",
          type: "boolean",
          show: true,
        },
        {
          key: "is_block_customer",
          name: "Block Customer",
          type: "boolean",
          show: true,
        },
        {
          key: "do_not_override",
          name: "Do Not Override",
          type: "boolean",
          show: true,
        },
        {
          key: "is_auto_assignable",
          name: "Auto Assignable",
          type: "boolean",
          show: true,
        },
      ],
    };
  },
  computed: {
    crmCategories() {
      return this.store.state.crmCategories;
    },
  },
  watch: {
    active(newVal) {
      if (newVal === "statuses") {
        this.loadCrmStatuses();
      }
    },
  },
  methods: {
    createCategory() {
      this.loadAddBtn = true;
      http
        .fetch("/crm/categories", this.newCategory, true)
        .then((data) => {
          this.$store.commit("addCrmCategory", data);
          this.newCategory = {};
          this.loadAddBtn = false;
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
    generateSlug() {
      if (this.newCategory.slug === undefined) {
        this.newCategory.slug = this.newCategory.name
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "");
      }
    },
    loadCrmStatuses() {
      this.statusesLoading = true;
      http
        .fetch("/crm-status")
        .then((data) => {
          this.crmStatuses = data.data || [];
          this.statusesLoading = false;
        })
        .catch(() => {
          this.statusesLoading = false;
        });
    },
    showAddStatusModal() {
      this.newStatus = {
        name: "",
        type: 3,
        color: "#6c757d",
        is_pay_before: false,
        is_block_customer: false,
        do_not_override: false,
        is_auto_assignable: true,
      };
      this.statusModal = new bootstrap.Modal(this.$refs.addStatusModal, {
        backdrop: "static",
      });
      this.statusModal.show();
    },
    createStatus() {
      this.savingStatus = true;
      const data = {
        ...this.newStatus,
        is_pay_before: this.newStatus.is_pay_before ? 1 : 0,
        is_block_customer: this.newStatus.is_block_customer ? 1 : 0,
        do_not_override: this.newStatus.do_not_override ? 1 : 0,
        is_auto_assignable: this.newStatus.is_auto_assignable ? 1 : 0,
      };
      http
        .fetch("/crm-status", data, true)
        .then(() => {
          this.statusModal.hide();
          this.savingStatus = false;
          this.loadCrmStatuses();
        })
        .catch(() => {
          this.savingStatus = false;
        });
    },
    updateStatusField(item, field, value) {
      let finalValue = value;
      if (
        field === "is_pay_before" ||
        field === "is_block_customer" ||
        field === "do_not_override"
      ) {
        finalValue = value ? 1 : 0;
      }

      const data = { [field]: finalValue };
      http
        .fetch("/crm-status/" + item.id, data, false, "PUT")
        .then(() => {
          // Update the local data
          const index = this.crmStatuses.findIndex((s) => s.id === item.id);
          if (index !== -1) {
            this.crmStatuses[index][field] = value;
          }
        })
        .catch(() => {});
    },
    deleteStatus(status) {
      if (confirm("Are you sure you want to delete this status?")) {
        http
          .fetch("/crm-status/" + status.id, {}, true, "DELETE")
          .then(() => {
            this.loadCrmStatuses();
          })
          .catch(() => {});
      }
    },
  },
};
</script>
